export const MATCHES_FETCH = "search.MATCHES_FETCH";
export const MATCHES_FETCH_FAILED = "search.MATCHES_FETCH_FAILED";
export const MATCHES_FETCH_SUCCESSFULLY = "search.MATCHES_FETCH_SUCCESSFULLY";

export const MATCHES_FETCH_LOAD_MORE = "search.MATCHES_FETCH_LOAD_MORE";
export const MATCHES_FETCH_LOAD_MORE_FAILED = "search.MATCHES_FETCH_LOAD_MORE_FAILED";
export const MATCHES_FETCH_LOAD_MORE_SUCCESSFULLY = "search.MATCHES_FETCH_LOAD_MORE_SUCCESSFULLY";